exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group input[type=file][data-v-9b60f932] {\n    width: 100% !important;\n    position: relative;\n    opacity: 100 !important;\n    padding: 7px 15px !important;\n}\n", ""]);

// exports
